module.exports = __webpack_public_path__ + "static/media/openclaw.12977f9b.svg";